import axios from "axios";

export const fetchAllAttributesApi = async (token, signal, pageNr=null) => {
  // fetches all existing attributes from the server
  // token (String): bearer token used for authentication 
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  // pageNr (Number): the new page nr requested by the user (pagination)
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      }, 
    };
    let pageNrQueryParam = "";
    if(pageNr){
      pageNrQueryParam = `?pageNr=${pageNr}`; 
    }
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/attributes${pageNrQueryParam}`, config, { signal });
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};


export const createAttributeApi = async (token, name, signal) => {
  // post request to the server to create a new attribute 
  // token (String): bearer token used for authentication 
  // name (String): the name of the attribute to be created 
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  // pageNr (Number): the new page nr requested by the user (pagination)
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/attributes`,
      {name: name},
      config,
      { signal }
    );
    return data;
  } catch (error) {
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};

  export const deleteAttributeApi = async (token, id, signal) => {
  // delete request to the server to delete an existing attribute 
  // token (String): bearer token used for authentication 
  // id (String): the id of the attribute to be deleted
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        }, 
      };
      const { data } = await axios.delete(`${process.env.REACT_APP_API_URL}/api/attributes/${id}`, config, { signal });
      return data;
    } catch (error) {
      //status code not in 200s
      if (!(error.name === "AbortError" || error.name === "CanceledError")) {
        // custom error message from back end
        const newErr = new Error(error.response?.data?.message);
        newErr.status = error.response?.request?.status;
        throw newErr;
      }
    }
  };

  export const updateAttributeApi = async (token, id, name, signal) => {
  // put request to the server to update an existing attribute 
  // token (String): bearer token used for authentication 
  // id (String): the id of the attribute to be deleted
  // name (String): the updated name for the attribute
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/attributes/${id}`,
        {name: name},
        config,
        { signal }
      );
      return data;
    } catch (error) {
      if (!(error.name === "AbortError" || error.name === "CanceledError")) {
        // custom error message from back end
        const newErr = new Error(error.response?.data?.message);
        newErr.status = error.response?.request?.status;
        throw newErr;
      }
    }
  };